import InventoryEditNotes from './InventoryEditNotes'
export default InventoryEditNotes
